import { render } from "./LeaderboardPodiumElement.vue?vue&type=template&id=8cd1a36e&scoped=true"
import script from "./LeaderboardPodiumElement.vue?vue&type=script&lang=js"
export * from "./LeaderboardPodiumElement.vue?vue&type=script&lang=js"

import "./LeaderboardPodiumElement.vue?vue&type=style&index=0&id=8cd1a36e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cd1a36e"]])

export default __exports__